<template>
  <el-row>
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header">
          <span>{{ service.name }}</span>
        </div>
        <el-row>
          <el-col :span="6">
            <p><strong>Name:</strong> {{ service.name }}</p>
            <p><strong>Carrier Code:</strong> {{ service.code }}</p>
            <p><strong>Consignment Code:</strong> {{ service.con }}</p>
            <p><strong>Label Code:</strong> {{ service.service_label }}</p>
            <p><strong>EDI Code:</strong> {{ service.edi }}</p>
            <p><strong>TIG Code:</strong> {{ service.chainit }}</p>
          </el-col>
          <el-col :span="6">
            <p><strong>Items Minimum:</strong> {{ service.items_min }}</p>
            <p><strong>Items Maximum:</strong> {{ service.items_max }}</p>
            <p><strong>Weight Minimum:</strong> {{ service.weight_min }} kg</p>
            <p><strong>Weight Maximum:</strong> {{ service.weight_max }} kg</p>
            <p><strong>Volume Minimum:</strong> {{ service.volume_min }} m³</p>
            <p><strong>Volume Maximum:</strong> {{ service.volume_max }} m³</p>
            <p><strong>Default Cubic:</strong> {{ service.default_cubic }} m³</p>
            <p><strong>Warn Chargeable Weight:</strong> {{ service.warn_chweight }} kg</p>
            <p><strong>Warn Length:</strong> {{ service.warn_length }} cm</p>
            <p><strong>Allow Dangerous Goods:</strong> {{ service.allow_dg ? 'Yes' : 'No' }}</p>
          </el-col>
          <el-col :span="6">
            <p><strong>Configuration Item Prefix Required:</strong> {{ service.config_itm_prefix_req ? 'Yes' : 'No' }}</p>
            <p><strong>Configuration Item Prefix Default:</strong> {{ service.config_itm_prefix_def }}</p>
            <p><strong>Configuration Item Minimum Default:</strong> {{ service.config_itm_min_def }}</p>
            <p><strong>Configuration Item Maximum Default:</strong> {{ service.config_itm_max_def }}</p>
            <p><strong>Hide From Pickups:</strong> {{ service.hide_from_pickups ? 'Yes' : 'No' }}</p>
            <!-- eslint-disable vue/no-v-html -->
            <p><strong>Item Rules:</strong> <span v-html="humaniseRule(service.item_rules)" /></p>
          </el-col>
          <el-col :span="6">
            <p><strong>Service Supports PO Box:</strong> {{ service.service_supports_pobox ? 'Yes' : 'No' }}</p>
            <p><strong>Service Supports Tailgate:</strong> {{ service.service_supports_tailgate ? 'Yes' : 'No' }}</p>
            <p><strong>Service Supports Timeslot:</strong> {{ service.service_supports_timeslot ? 'Yes' : 'No' }}</p>
            <p><strong>Service Supports Moffett:</strong> {{ service.service_supports_moffett ? 'Yes' : 'No' }}</p>
            <p><strong>Service Supports Hand Unload:</strong> {{ service.service_supports_handunload ? 'Yes' : 'No' }}</p>
            <p><strong>Service Supports Two Man Lift:</strong> {{ service.service_supports_twomanlift ? 'Yes' : 'No' }}</p>
            <p><strong>Service Supports Saturday Delivery:</strong> {{ service.service_supports_saturdaydelivery ? 'Yes' : 'No' }}</p>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'ServicesPeek',
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  methods: {
    humaniseRule (rule) {
      if (!rule) return 'None'
      return 'If ' + rule.replace('1', 'Satchel')
        .replace('2', 'Carton')
        .replace('3', 'Pallet')
        .replace('4', 'Skid')
        .replace('5', 'Other')
        .replace('6', 'Virtual DG')
        .replace('7', 'Cage')
        .replace('8', 'Document')
        .replace('?', '<i>Then</i>')
        .replace(':', '<i>Else</i>')
    }
  }
}
</script>
<style scoped>

</style>
